import { NgModule } from '@angular/core';
import { ReportAnonymousModeToggleComponent } from './report-anonymous-mode-toggle.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
  declarations: [
    ReportAnonymousModeToggleComponent
  ],
    imports: [
        MatSlideToggleModule,
        SharedModule,
    ],
  exports: [
    ReportAnonymousModeToggleComponent
  ]
})
export class ReportAnonymousModeToggleModule { }
